"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const next13_enums_colors_1 = __importDefault(require("@gerenciatd/next13.enums.colors"));
const CarM = (props) => {
    let { color } = props;
    let layoutSize = {};
    if (props.layoutSize) {
        ({ layoutSize } = props);
    }
    let { width, height, insetPosition } = props;
    const size = {};
    /* damos valor a la otra coordenada en caso de no indicarse */
    if (width && width !== "auto") {
        size.width = width;
        if (!layoutSize.width) {
            layoutSize.width = width;
        }
    }
    if (height && height !== "auto") {
        size.height = height;
        if (!layoutSize.height) {
            layoutSize.height = height;
        }
    }
    const fill = (0, next13_enums_colors_1.default)(color);
    return (react_1.default.createElement("div", { className: "svg-layout-size", style: Object.assign({}, layoutSize) },
        react_1.default.createElement("svg", Object.assign({ focusable: "false", viewBox: "0 0 200 200" }, size, { style: Object.assign({}, insetPosition), fill: fill, "aria-label": "", "aria-hidden": "true", role: "presentation" }),
            react_1.default.createElement("path", { d: "M175.3 68.5l-6.8-28.6c-.1-.3-.1-.5-.2-.7-5-14.6-10.6-26.7-28.9-26.7H60.6c-18 0-24.2 9.9-29 27.1 0 .1-.1.2-.1.3l-6.8 28.6C11 70.9.5 82.9.5 97.3v29.2c0 11.4 6.5 21.2 16 26.1v15.7c0 10.5 8.6 19.1 19.1 19.1h9.8c10.5 0 19.1-8.6 19.1-19.1v-12.5h71v12.5c0 10.5 8.6 19.1 19.1 19.1h9.8c10.5 0 19.1-8.6 19.1-19.1v-15.7c9.5-4.9 16-14.7 16-26.1V97.3c0-14.4-10.5-26.4-24.2-28.8zM53.1 30.7c.9-.9 2.4-1.9 7.5-1.9h78.9c5.7 0 8.1 0 13.3 15.3l5.7 23.9h-117l5.8-24.2c1.9-6.9 3.8-11.2 5.8-13.1zM29.8 84.3h140.4c7.2 0 13 5.8 13 13v10.9c-1.8-11.5-11.7-20.3-23.7-20.3-13.2 0-24 10.8-24 24s10.8 24 24 24c12 0 21.9-8.8 23.7-20.3v10.9c0 7.2-5.8 13-13 13H29.8c-7.2 0-13-5.8-13-13v-10.9c1.8 11.5 11.7 20.3 23.7 20.3 13.2 0 24-10.8 24-24s-10.8-24-24-24c-12 0-21.9 8.8-23.7 20.3V97.3c0-7.2 5.8-13 13-13zm137.4 27.6c0 4.3-3.5 7.7-7.7 7.7-4.3 0-7.7-3.5-7.7-7.7 0-4.3 3.5-7.7 7.7-7.7 4.3 0 7.7 3.5 7.7 7.7zm-134.4 0c0-4.3 3.5-7.7 7.7-7.7s7.7 3.5 7.7 7.7c0 4.3-3.5 7.7-7.7 7.7s-7.7-3.4-7.7-7.7zm15.4 56.5c0 1.5-1.3 2.8-2.8 2.8h-9.8c-1.5 0-2.8-1.3-2.8-2.8v-12.5h15.5v12.5zm116.2 2.8h-9.8c-1.5 0-2.8-1.3-2.8-2.8v-12.5h15.5v12.5c-.1 1.5-1.4 2.8-2.9 2.8z" }))));
};
exports.default = CarM;
//# sourceMappingURL=index.js.map